import { render, staticRenderFns } from "./HighlightedSpan.vue?vue&type=template&id=07ff0475&"
import script from "./HighlightedSpan.vue?vue&type=script&lang=js&"
export * from "./HighlightedSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports